// Constantes del Portal de seguimiento (incidencias y proyectos CX).
// Colores, catálogos y mapeos usados por todas las vistas del portal.

export const AREA_COLORS = {
  Operación: "#d97706",
  Comercial: "#4f46e5",
  CX: "#7c3aed",
  PM: "#2563eb",
  Seguridad: "#dc2626",
  MKT: "#db2777",
  Sistemas: "#0d9488",
  Distribución: "#059669",
  "Diseño de soluciones": "#0891b2",
  Mantenimiento: "#ea580c",
  Legal: "#334155",
  RH: "#65a30d",
  Otros: "#64748b",
  Implementación: "#c026d3",
  Compras: "#0284c7",
};

// Paleta de respaldo para áreas no catalogadas (color estable por hash).
export const PALETTE = [
  "#4f46e5", "#0d9488", "#d97706", "#db2777", "#2563eb", "#059669",
  "#7c3aed", "#dc2626", "#0891b2", "#ea580c", "#65a30d", "#0284c7",
];

export const AREA_LIST = Object.keys(AREA_COLORS);

export const CATEGORIAS = [
  "Requerimiento", "Seguimiento", "Issue", "Consulta", "Claim", "Proyecto",
];

export const CANALES = ["Mail", "Whatsapp", "Telefónico", "Conferencia", "Presencial"];

export const ESTATUS = ["En proceso", "Concluido", "Stand by", "Declinado"];

export const ESTATUS_COLOR = {
  "En proceso": "#2563eb",
  Concluido: "#16a34a",
  "Stand by": "#d97706",
  Declinado: "#64748b",
};

// % de avance implícito según estatus (cuando el registro no trae avance explícito).
export const AVANCE_ESTATUS = {
  "En proceso": 50,
  Concluido: 100,
  "Stand by": 20,
  Declinado: 0,
};

export const PRIORIDADES = ["Alta", "Medio", "Baja"];

export const PRIORIDAD_COLOR = {
  Alta: "#dc2626",
  Medio: "#d97706",
  Media: "#d97706",
  Baja: "#0284c7",
};

export const SLA_COLOR = {
  "A tiempo": "#16a34a",
  "Por vencer": "#d97706",
  Vencido: "#dc2626",
  "Sin fecha": "#94a3b8",
  Concluido: "#16a34a",
  Tarde: "#dc2626",
};

export const DIA = 24 * 60 * 60 * 1000;
